import { render, staticRenderFns } from "./PayMongoDetails.vue?vue&type=template&id=677c50ee&"
import script from "./PayMongoDetails.vue?vue&type=script&lang=js&"
export * from "./PayMongoDetails.vue?vue&type=script&lang=js&"
import style0 from "./PayMongoDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports